export const environment = {
  production: false,
  dataEncryptionEnabled: true,
  apiEndpoint: 'https://zg-dev.gnsgsw.com/backend/public/api/',
};
